import { getTestNode, handleTestSelection } from "./testSelection.js";
import { handleDiscountPanelSelection } from "./discountPanelSelection.js";
import { removeItem } from "./index.js";

export function addSelectedCustomPanel(panelId, selectProp, supportObj) {
  let { selectedCustomPanelIdList } = supportObj;
  // if the custom panel is selected, return
  if (selectedCustomPanelIdList.includes(panelId)) {
    return;
  }
  // select custom panel and its content
  handleCustomPanelSelection(panelId, selectProp, true, supportObj);
  // add it to selected custom panel list
  selectedCustomPanelIdList.push(panelId);
  // remove test and bundles in this custom panel from selected list
  removeTestAndPanel(panelId, supportObj);
}

export function removeSelectedCustomPanel(panelId, selectProp, supportObj) {
  let { selectedCustomPanelIdList, selectedShortcutIdList, shortcutList, selectedTestIdList, selectedDiscountPanelIdList, selectedXChooseYPanelIdList } = supportObj;
  // remove custom bundle itself from selected list
  if (selectedCustomPanelIdList.includes(panelId)) {
    removeItem(panelId, selectedCustomPanelIdList);
  }
  
  // check whether belong to any selected shortcuts
  let selectedShortcuts = shortcutList
    .filter(shortcut => selectedShortcutIdList.includes(shortcut.id));
  selectedShortcuts.forEach(shortcut => {
    removeCustomPanelInShortcut(panelId, shortcut, selectProp, shortcut.id, selectedShortcutIdList, supportObj);
  });
  // de-select customBundle itself and its content
  handleCustomPanelSelection(panelId, selectProp, false, supportObj);

  // remove custom bundle in edit order list if any
  if (selectProp === "isSelect") {
    removeCustomPanelInEditOrder(panelId, supportObj);
  }
}

export function handleCustomPanelSelection(panelId, selectProp, isSelectPanel, supportObj) {
  // select/de-select custom panel itself according to isSelectPanel value
  let { bundleList, testNodeList } = supportObj;
  let customPanel = bundleList.find(bundle => bundle.bundleId === panelId);
  if (!customPanel) {
    return;
  }
  customPanel[selectProp] = isSelectPanel;
  // select/de-select all xChooseY bundles in this custom panel according to isSelectPanel value
  let xChooseYPanelIdList = [];
  if (customPanel.selectedXChooseYPanelList) {
    customPanel.selectedXChooseYPanelList.forEach(panel => {
      xChooseYPanelIdList.push(panel.bundleId);
      panel[selectProp] = isSelectPanel;
      // get tests belong to current xChooseY panel
      let testIdList = panel.selectedZoomerIdList.concat(panel.selectedSupplementIdList);
      let selectedTestNodeList = testNodeList.filter(node => testIdList.includes(node.id));
      selectedTestNodeList.forEach(node => {
        handleTestSelection(node, selectProp, isSelectPanel);
      });
    })
  }
  // select/de-select all tests and discount panels in this panel according to isSelectPanel value
  customPanel.bundleItemList.forEach(content => {
    if (content.itemType === "official bundle") {
      if (content.itemId) {
        // exclude xChooseY panels to get discount panels
        if (!xChooseYPanelIdList.includes(content.itemId)) {
          handleDiscountPanelSelection(content.itemId, selectProp, isSelectPanel, supportObj);
        }
      }
    }
    else { // test
      if (content.itemId) {
        let currentNode = getTestNode(testNodeList, content.itemId);
        handleTestSelection(currentNode, selectProp, isSelectPanel);
      }
    }
  });

  // if de-select custom panel, need to initialize selectedXChooseYPanelList value
  if (!isSelectPanel) {
    customPanel.selctedXChooseYPanelList = [];
  }
}

function removeTestAndPanel(panelId, supportObj) {
  let { bundleList, selectedTestIdList, selectedDiscountPanelIdList, selectedXChooseYPanelIdList } = supportObj;
  let customPanel = bundleList.find(b => b.bundleId === panelId);
  // remove custom panel's test and panels if is selected earlier
  customPanel.bundleItemList.forEach(content => {
    if (content.itemType === "official bundle") {
      if (content.itemId) { // remove discount panel or xChooseY panel
        removeItem(content.itemId, selectedDiscountPanelIdList);
        removeItem(content.itemId, selectedXChooseYPanelIdList);
      }
    }
    else { // remove test
      if (content.itemId) {
        removeItem(content.itemId, selectedTestIdList);
      }
    }
  });
}


function removeCustomPanelInEditOrder(panelId, supporObj) {
  let { editOrderItemList, shortcutList } = supporObj;
  let customPanel = editOrderItemList.find(item => item.item_id === panelId && item.category === "customPanel");
  removeItem(customPanel, editOrderItemList);
  // remove shortcut if the test is included in shortcut
  let shortcuts = editOrderItemList.filter(item => item.category === "shortcut");
  shortcuts.forEach(shortcut => {
    let shortcutOnMenu = shortcutList.find(s => s.id === shortcut.item_id);
    removeCustomPanelInShortcut(panelId, shortcutOnMenu, "isSelect", shortcut, editOrderItemList, supporObj);
  })
}

function removeCustomPanelInShortcut(customPanelId, shortcut, selectProp, removedItem, removeFromList, supporObj) {
  if (!shortcut) {
    return;
  }
  let { 
    selectedTestIdList, 
    selectedDiscountPanelIdList, 
    selectedCustomPanelIdList, 
    selectedXChooseYPanelIdList 
  } = supporObj;
  let {
    testIdList,
    discountPanelIdList,
    customPanelIdList,
    selectedXChooseYPanelList,
  } = shortcut;
  let index = customPanelIdList.indexOf(customPanelId);
  if (index > -1) {
    // de-select & remove current shortcut
    shortcut[selectProp] = false;
    removeItem(removedItem, removeFromList);
    // add remaining test to selected test id list
    testIdList.forEach(id => {
      selectedTestIdList.push(id);
    });
    // add remaining discount panel to selected discount panel list
    discountPanelIdList.forEach(id => {
      selectedDiscountPanelIdList.push(id);
    });
    // add remaining custom panel to selected custom panel list
    let remainingCustomPanelIdList = [...customPanelIdList];
    remainingCustomPanelIdList.splice(index, 1);
    remainingCustomPanelIdList.forEach(id => {
      selectedCustomPanelIdList.push(id);
    });
    // add remaining x choose y panel to selected list
    if (selectedXChooseYPanelList) {
      selectedXChooseYPanelList.filter(p => !p.customPanelId).forEach(panel => {
        selectedXChooseYPanelIdList.push(panel.bundleId);
      });
    }
  }
}